import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactReduxContext } from 'react-redux';
import { Button } from '@ff-os/shared-react/components/buttons/button/Button';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { Image } from '@ff-os/shared-react/components/image/Image';
import { Spinner } from '@ff-os/shared-react/components/loaders/spinner/Spinner';
import { WindowBody } from '@ff-os/shared-react/components/window/partials/WindowBody';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { Window } from '@ff-os/shared-react/components/window/Window';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { toQrCode } from '@ff-os/shared-utils/to-qr-code';
import { createQrArPreview } from './helpers/ar-preview/createQrArPreview';
import styles from './WindowArPreviewQrCode.module.scss';

export const WindowArPreviewQrCode = ({ onClose }: Props) => {

    const { t } = useTranslation();
    const { store } = useContext(ReactReduxContext);
    const [url, setUrl] = useState<string>();
    const [expiresOn, setExpiresOn] = useState<number>();
    const isMobile = useMobile();

    useEffect(() => {

        if (!expiresOn) {
            ((async () => {

                const arPreview = await createQrArPreview(store);

                const qrCodeUrl = await toQrCode(arPreview.previewUrl);
                setUrl(qrCodeUrl);

                setExpiresOn(arPreview.expiresOn);
                setTimeout(() => {
                    setUrl(undefined);
                    setExpiresOn(undefined);
                }, arPreview.expiresOn - Date.now());

            })());
        }

    }, [expiresOn]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Window className={styles.window} close={onClose} size='md' mobileOrigin='center'>
            <WindowHeader onClose={onClose} />
            <WindowBody>
                <Grid justify='center' direction={isMobile ? 'column' : 'row'} align='center' gap='l'>
                    <Cell>
                        <Grid direction='column' gap='xs' align='center'>
                            <Cell>
                                {url ? (
                                    <Image crossOrigin='anonymous' src={url} alt='qr-code' />
                                ) : (
                                    <Spinner className={styles.spinner} spinnerSize='medium' overlaySize='auto' />
                                )}
                            </Cell>
                            {!isMobile && (
                                <Cell>
                                    <div className={styles.text}>
                                        <Icon
                                            strokeWidth={0}
                                            type='phone--filled'
                                            className={styles.inlineIcon} />
                                        {t('windows.ar_preview.scan_from_other_device')}
                                    </div>
                                </Cell>
                            )}
                        </Grid>
                    </Cell>
                    <Cell>
                        <Grid direction='column' gap='m' align='center' justify='center'>
                            {!isMobile && (
                                <Cell>
                                    <Icon type='3d-cube--filled' className={styles.icon} />
                                </Cell>
                            )}
                            <Cell>
                                <h2 className={styles.heading}>
                                    {t('windows.ar_preview.experience')}
                                </h2>
                            </Cell>
                            <Cell>
                                <p className={styles.text}>
                                    {t('windows.ar_preview.scan')}
                                </p>
                            </Cell>
                            <Cell>
                                <Button onClick={onClose}>
                                    {t('commons.close')}
                                </Button>
                            </Cell>
                        </Grid>

                    </Cell>
                </Grid>
            </WindowBody>
        </Window>
    );
};

type Props = {
    onClose: () => void;
};